
namespace Gordic.Epk.WebControls {

    interface EpkTypPozadPodCard {
        typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk | null,
        typ_pozad_pod_txt: string
    }

    class IGEpkMobileCardOpt {
        /** první řádek */
        first: string
        /** druhý řádek */
        second: string
        /** třetí řádek (volitelný) */
        thirdOptional?: string
        /** datum žádosti */
        date: string
    };

    const { gcontent } = Decorators;

    @gcontent
    export class GEpkGridCard extends GContentBase<GEpkDbParamsNew> {

        private typPozadPod: Wfl.Interface.TypPozadavkuEpk | null;
        private TypSeznamu: Wfl.Interface.TypSeznamuEpk;
        private stavZadosti: Wfl.Interface.GWflczpvEnum;
        private uzo: any;
        private epk_termin: EpkTerminEnum;
        private common: GEpkCommon;
        private ixs_fun: string;

        public onContentReady() {
            this.create();
        }

        private main: JQuery<HTMLElement>;
        private cmdBarElement: JQuery<HTMLElement>;

        private create() {

            this.createCounter(0);

            this.common = new GEpkCommon();
            this.common.setInitSettlementValues(this);

            this.commandBar(this.getCommandbarParams());
            //this.cmdBarElement = $("div.mobilegrid-class").parent().parent().children(".ui-dialog-buttonset");
            //$(".closeButton").last().focus();

            this.createHiddenGrid();
            this.main = $.newDiv("epk-gridmobile-cnt").appendTo(this.element);
            this.createForm(this.main);
            this.createMenubar();


            //$(".closeButton").last().gfield("focus");



        }

        //#region --- FORM ---

        private createForm(el: JQuery<HTMLElement>) {

            this.typPozadPod = null;

            const form = $("<div>").appendTo(el);
            const Form = new Gordic.Forms.Form({
                name: "FormCard",
                layoutDescriptor: "L2M2S1, L-12-12-0, M-12-12-0, S-12-12-0" 
            });

            Form.addSection();
            Form
                .addRow()
                //.addRow({
                //    label: "Termín",
                //    //customClass: "w-6"
                //}) 
                .addField("gselectbox", {
                    //factors: [
                    //    { caption: "jres:32000964", factor: "TE" }, //RC 32000964 : Termín
                    //],
                    graphicInput: "hidden",
                    name: "termin",
                    initialValue: this.getTerminInitialValue(this.epk_termin),     // buď se doplní výchozí hodnota Cokoliv nebo se nastaví předaná hodnota např. z notifikace
                    data: this.getTermin(),
                    itemTemplate: (template) => {
                        //return template?.caption;
                        return $.newDiv().html("jres:32000938: <b>" + template?.caption + "</b>");
                    },
                    change: (ev, obj) => {
                        this.epk_termin = obj.value == null ? EpkTerminEnum.Cokoliv : obj.value.value;
                        this.reload();
                    },
                    dropdown: true,
                    customClass: "w-6"
                })
            //Form.addSection();

            Form
                .addField("gselectbox", {
                    graphicInput: "hidden",
                    initialValue: {
                        typ_pozad_pod: null, typ_pozad_pod_txt: "jres:32000898" //RC 32000898 : Vše
                    },
                    name: "typPozadavku",
                    data: this.getTypPozadPod(),
                    dropdown: true,
                    itemTemplate: (template) => {
                        //return template?.typ_pozad_pod_txt;
                        return $.newDiv().html("jres:32000966: <b>" + template?.typ_pozad_pod_txt + "</b>"); //RC 32000966 : Žádost
                    },
                    change: (ev, obj) => {
                        this.typPozadPod = obj.value == null ? null : obj.value.typ_pozad_pod;
                        this.reload();
                    },
                    customClass: "w-6"

                })

            form.gform("createFrom", Form);
        }

        private getTypPozadPod() {

            var list: EpkTypPozadPodCard[] = [];

            let vse: EpkTypPozadPodCard = {
                typ_pozad_pod: null, typ_pozad_pod_txt: "jres:32000898" //RC 32000898 : Vše
            };
            list.push(vse);
            let podepsat: EpkTypPozadPodCard = {
                typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Podepsat, typ_pozad_pod_txt: "jres:32000565" //RC 32000565 : Podepsat
            };
            list.push(podepsat);
            let podepsatschvalit: EpkTypPozadPodCard = {
                typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit, typ_pozad_pod_txt: "jres:32000566" //RC 32000566 : Podepsat a schválit
            };
            list.push(podepsatschvalit);

            if (this.EpkParams.ssl_epk_plus! > -1 || (this.EpkParams.ssl_epk_plus! === -1 &&
                (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno ||
                    this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani))) {

                let schvalit: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Schvalit, typ_pozad_pod_txt: "jres:32000567" //RC 32000567 : Schválit
                };
                list.push(schvalit);
            }

            if (this.EpkParams.ssl_epk_plus! > 0) {
                let posoudit: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Posoudit, typ_pozad_pod_txt: "jres:32000568" //RC 32000568 : Posoudit
                };
                list.push(posoudit);
            }

            if (this.EpkParams.ssl_epk_plus === 2 || this.EpkParams.ssl_epk_plus === 3) {
                let vzitnavedomi: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi, typ_pozad_pod_txt: "jres:32000569" //RC 32000569 : Vzít na vědomí
                };
                list.push(vzitnavedomi);
            }

            if (this.EpkParams.ssl_epk_plus === 3) {
                let splnit: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Splnit, typ_pozad_pod_txt: "jres:32000570" //RC 32000570 : Splnit
                };
                list.push(splnit);
                let rozhodnout: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Rozhodnout, typ_pozad_pod_txt: "jres:32000571" //RC 32000571 : Rozhodnout
                };
                list.push(rozhodnout);
            }
     
            if (this.EpkParams.ssl_epk_plus2 === true) {
                let prideleni: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Prideleni, typ_pozad_pod_txt: "jres:32000653" //RC 32000653 : Přidělit
                };
                list.push(prideleni);
                let predat: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Predani, typ_pozad_pod_txt: "jres:32000652" //RC 32000652 : Předat
                };
                list.push(predat);
                let schvalitvyrizenispisu: EpkTypPozadPodCard = {
                    typ_pozad_pod: Wfl.Interface.TypPozadavkuEpk.Predani, typ_pozad_pod_txt: "jres:32000650" //RC 32000650 : Schválit vyřízení spisu
                };
                list.push(schvalitvyrizenispisu);
            }

            var view = new Gordic.Data.View<EpkTypPozadPodCard>(list);
            return view;
        }

        private getTermin() {
            var list: { caption: string, value: EpkTerminEnum }[] = [];
            list.push({ caption: "jres:32000963", value: EpkTerminEnum.Cokoliv }); //RC 32000963 : Vše
            list.push({ caption: "jres:32000935", value: EpkTerminEnum.Pred }); //RC 32000935 : Před
            list.push({ caption: "jres:32000936", value: EpkTerminEnum.TesnePred }); //RC 32000936 : Těsně před
            list.push({ caption: "jres:32000937", value: EpkTerminEnum.Po }); //RC 32000937 : Po

            var view = new Gordic.Data.View(list);
            return view;
        }

        private getTerminInitialValue(input: EpkTerminEnum) {
            var view = this.getTermin();
            var list = view.getDataRows();
            var initialValue = list[0];
            for (var i = 0; i < list.length; i++) {
                var item = list[i];
                if (input === item.value) {
                    initialValue = item;
                    break;
                }
            }
            return initialValue;
        }

        //#endregion


        private gridMobile: JQuery<HTMLElement>;

        private createHiddenGrid() {

            if (this.closed === true)
                return;

            this.viewMobile = new Gordic.Isl.View(Gordic.Isl.ElectronicSignatureBookRequest.list(rq => {
                var filters = this.getFilter(this.typPozadPod, this.epk_termin);
                return { filters: filters }
            }), {
                //filterPanel: this.filter,
                key: "ixp, ser_cislo, dat_pozad",
            });

            /**
                * přidat názvy sloupců do řetězce
                */
            function getStringNamesOfColumns(columns: GGridColumn<any>[]) {
                var columnList = "";
                for (var index = 0; index < columns.length; index++) {
                    // přidání čárky před přidaný název, z výjimkou prvního názvu
                    columnList = index === 0 ? columnList : columnList + ",";
                    columnList += columns[index].name;
                }
                return columnList;
            }

            function getSearchColumns(format: Gordic.Data.GridFormat) {
                /** sloupce na prohledávání */
                var searchColumns = [] as string[];
                for (var index = 0; index < format.columns.length; index++) {
                    var columns = format.columns[index];

                    if (columns.name !== undefined) {
                        searchColumns.push(columns.name);
                    }
                }
                return searchColumns;
            }

            function setFormat(format: Gordic.Data.GridFormat) {
                format
                    .addTextColumn({ name: "vec", caption: "jres:26265010", width: 250 }) //RC 26265010 : Věc
                format
                    .addTextColumn({ name: "typ_pozad_pod_txt", caption: "jres:32000042", width: 90 }) //RC 32000042 : Upřesnění
                format
                    .addDateTimeColumn({ name: "dat_vyriz_plan", caption: "jres:32000090", width: 140/*, fragment: "BASE"*/ }) //RC 32000090 : Termín
                format
                    .addTextColumn({ name: "ixp", caption: "jres:32000048", width: 120 }) //RC 32000048 : PID
            }

            const format = new Gordic.Data.GridFormat<Gordic.Wfl.Interface.GPodpisovaKnihaDto>();
            setFormat(format);
            const columns = getStringNamesOfColumns(format.columns);

            const columnList = getStringNamesOfColumns(format.columns);


            var defaultProfile: GridProfile<Gordic.Wfl.Interface.GPodpisovaKnihaDto> = {
                name: "jres:32000417", //RC 32000417 : Výchozí profil
                _locked: true,
                columnList: columnList
            };

            this.gridMobile = $.newDiv("epk-gridmobile-hidden").gautofit().appendTo(this.element);

            this.gridMobile.ggrid({
                data: this.viewMobile,
                name: "gridSeznam",
                renderMode: "auto",
                columnMode: "full",
                customClass: "epk-maingrid",
                navigationMode: "row",
                columns: format,
                searchColumns: getSearchColumns(format),
            });

            this.viewMobile.on("change", (opts) => {

                if (this.closed === true)
                    return;

                const rows = this.viewMobile.getDataRows();
                this.createElements(rows);
                this.endOperation("idLoad");
            });

        }

        private getCommandbarParams() {

            var params: MenuParams[] = [];

            params.push({
                action: this.actions.add(new GAction({
                    name: "actClose",
                    customClass: "closeButton",
                    caption: "jres:32000023", //RC 32000023 : Zavřít
                    run: (ev, ctx) => {
                        this.tryClose();
                    }
                }))
            })

            return params;
        }


        private createMenubar() {

            var params: MenuParams[] = [];

            params.push({
                favorite: true,
                action: new GAction({
                    name: "actSettlement",
                    icon: "fa-check-circle g-state-text g-state-success",
                    caption: "jres:32000946", //RC 32000946 : Hromadně vyřídit
                    run: () => {

                        if (this.closed === true)
                            return;

                        var rows = this.viewMobile.getDataRows();
                        if(rows.length > 0)
                            this.multiSettlement(Wfl.Interface.GWflczpvEnum.Povoleno, rows);
                    }
                })
            })

            params.push({
                favorite: true,
                action: new GAction({
                    name: "actSettlementReject",
                    icon: "fa-times g-state-text g-state-error",
                    caption: "jres:32000949", //RC 32000949 : Hromadně zamítnout
                    run: () => {

                        if (this.closed === true)
                            return;

                        var rows = this.viewMobile.getDataRows();
                        if (rows.length > 0)
                            this.multiSettlement(Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani, rows);
                    }
                })
            })

            params.push({
                align: "opposite",
                favorite: true,
                action: new GAction({
                    name: "actRefresh",
                    icon: "gi-refresh",
                    caption: "jres:32000908", //RC 32000908 : Občerstvit
                    run: () => {

                        if (this.closed === true)
                            return;

                        this.reload();
                    }
                })
            })

            this.menuBar(params);

        }

        private reload() {
            this.beginOperation({ id: "idLoad", text: "jres:32000950" }); //RC 32000950 : Probíhá načítání žádostí
            this.viewMobile.requestData();  // refresh
        }

        private getFilter(typ_pozad_pod?: number | null, epk_termin?: EpkTerminEnum | null) {

            var obj: any = {};
            if (epk_termin != null) {
                obj["epk_termin"] = epk_termin;
            }

            obj["typ_seznamu"] = this.TypSeznamu;
            obj["ssl_epk_plus"] = this.EpkParams.ssl_epk_plus;
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti)
                obj["stav_zadosti"] = this.stavZadosti;
            if (this.uzo != null)
                obj["uzo"] = this.uzo;
            if (typ_pozad_pod != null)
                obj["typ_pozad_pod"] = typ_pozad_pod;

            return obj;
        }

        private viewMobile: Gordic.Data.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>;

        private createElements(rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {
            this.createElement(rows);
            this.createCounter(rows.length);
        }

        private counterEl: JQuery<HTMLElement>;
        private bottomPanelEl: JQuery<HTMLElement>;

        private createCounter(count: number) {
            if (this.counterEl == null) {
                this.bottomPanelEl = $("<div class='epk-bottom-panel'>");
                let statusWidget = $("<div class='epk-status-widget'>").appendTo(this.bottomPanelEl).text("jres:32000945: "); //RC 32000945 : Počet
                this.counterEl = $("<b class='g-state-text g-state-active'>").appendTo(statusWidget);
                this.bottomPanelEl.appendTo(this.element.parent());
            }
            this.counterEl.text(count);
            //this.counterEl.focus();

        }

        private panel: JQuery<HTMLElement>;

        private getIcon(typ_pozad_pod?: number | Wfl.Interface.TypPozadavkuEpk | null) {

            var result = {
                icon1: "gi gi-tick",
                icon2: ""
            };

            if (typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat) {
                result.icon1 = "gi gi-pen";
            }
            else if (typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {
                result.icon1 = "gi gi-pen";
                result.icon2 = "gi gi-schvaleno";
            }
            else if (typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Schvalit) {
                result.icon1 = "gi gi-schvaleno";
            }
            else if (typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Posoudit) {
                //<i class="fa-solid fa-scale-balanced" > </i>
                //result.icon1 = "gi gi-balancovani";
                result.icon1 = "fa fa-balance-scale";
            }
            else if (typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi) {
                result.icon1 = "gi gi-detail";
            }

            return result;
        }

         /** nastavení priority */
        private setPriorita(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            var data = { text: "", customClass: "", icon: "" }
            var priorita = row.priorita;
            if (priorita === 0)
                data = { text: "jres:32000311", customClass: "g-state-text g-state-info", icon: "" }; //RC 32000311 : Nízká priorita
            else if (priorita === 1)
                data = { text: "jres:32000312", customClass: "g-state-text g-state-warning", icon: "fa-exclamation" }; //RC 32000312 : Střední priorita
            else if (priorita === 2)
                data = { text: "jres:32000313", customClass: "g-state-text g-state-important", icon: "fa-exclamation" }; //RC 32000313 : Vysoká priorita
            else if (priorita === 3)
                data = { text: "jres:32000746", customClass: "g-state-text g-state-error", icon: "fa-exclamation" }; //RC 32000746 : Kritická priorita
            else {
                if (priorita != null)
                    data = { text: "jres:32000312", customClass: "g-state-text g-state-warning", icon: "fa-exclamation" }; //RC 32000312 : Střední priorita
            }
            return data;
        }

        private createElement(data: Wfl.Interface.GPodpisovaKnihaDto[]) {

            var that = this;

            if (this.panel != null) {
                this.panel.empty();     // clear panel after refresh/reload
            }
            else {
                this.panel = $.newDiv("epk-gridmobile").appendTo(that.main);
            }

            function createCard(item: Wfl.Interface.GPodpisovaKnihaDto, index: number) {

                // věc
                var vec = "jres:32000940"; //RC 32000940 : Žádost EPK
                if (item.vec != null && item.vec !== "") {
                    vec = item.vec.trim();
                }
                // typ požadavku
                var typ_pozad_pod = getTypPozadPodTxtUtils(item.typ_pozad_pod).trim();
                // upřesnění
                var upresneni = item.typ_pozad_pod_txt == null ? "" : item.typ_pozad_pod_txt.trim();

                var priorita = that.setPriorita(item);

                var opt: IGEpkMobileCardOpt = {
                    first: vec,
                    thirdOptional: priorita.text,
                    second: item.typ_pozad_pod_txt == null ? "" : item.typ_pozad_pod_txt.trim(),
                    date: item.dat_vyriz_plan == null ? "" : Gordic.Templates.Formatters.date(item.dat_vyriz_plan, "date")
                }

                // ----

                const container = $.newDiv("container");

                //$.newDiv("title").text(opt.first).appendTo(container);
                //return container;

                const left = $.newDiv("left").appendTo(container);
                left.on("click", (evt) => {
                    evt.preventDefault();
                    that.clickOnLeft(evt, item);
                });

                $("<i>").addClass("fa fa-times").appendTo(left);

                const content = $.newDiv("content").appendTo(container);
                content.on("click", (evt) => {
                    evt.preventDefault();
                    that.clickOnDetail(evt, item, index);
                });

                const rows = $.newDiv("rows").appendTo(content);
                const firstRow = $.newDiv("row").appendTo(rows);
                const firstRowText = $.newDiv("text").appendTo(firstRow);

                // first
                const detail = $.newDiv("title").text(opt.first).appendTo(firstRowText);
                //detail.on("click", (evt) => {
                //    evt.preventDefault();
                //    that.clickOnDetail(evt, item, index);
                //});

                // second
                const secondRow = $.newDiv("row middle").appendTo(rows);
                $.newDiv("color").gcolorpickerfield({
                    type: "epk",
                    globalSettings: that.globalSettings,
                    readonly: true,
                    uzo: item.uzo,
                }).appendTo(secondRow);
                $.newDiv("text").text(opt.second).appendTo(secondRow);

                // third (optional)
                const thirdRow = $.newDiv("row").appendTo(rows);

                if (priorita.icon !== "") {
                    $("<i>")
                        .addClass("fa fa-exclamation-triangle priorita-icon")
                        .addClass(priorita.customClass)
                        .appendTo(thirdRow);
                }

                $.newDiv("text").text(opt.thirdOptional == null ? "" : opt.thirdOptional).appendTo(thirdRow);
                $.newSpan("date").text(opt.date).appendTo(thirdRow);

                const right = $.newDiv("right right-swipe").appendTo(container);    // right-swipe
                right.on("click", (evt) => {
                    evt.preventDefault();
                    that.clickOnRight(evt, item);
                });

                const iconObj = that.getIcon(item.typ_pozad_pod);
                if (iconObj.icon2 !== "") {
                    const two = $.newDiv("two-icons")
                        .appendTo(right);
                    $("<i>")
                        .addClass(iconObj.icon1)
                        .appendTo(two);
                    $("<i>")
                        .addClass("second-icon")
                        .addClass(iconObj.icon2)
                        .appendTo(two);
                }
                else {
                    $("<i>")
                        .addClass(iconObj.icon1)
                        .appendTo(right);
                }

                return container;
            }

            for (var i = 0; i < data.length; i++) {
                createCard(data[i], i).appendTo(this.panel);
            }
            this.registerSwipeEvents(this.panel);

        }

        private viewMobileIndex: number;

        private clickOnDetail(evt, item: Wfl.Interface.GPodpisovaKnihaDto, index: number) {

            if (this.closed === true)
                return;

            if (item == null || item.ixp == null || item.ser_cislo == null) {
                //RC 32000941 : Upozornění
                this.dialogs.error("jres:32000941", "jres:32000942");  //RC 32000942 : Nebyli předány povinné atributy pro otevření detailu žádosti.
                return;
            }
            this.viewMobileIndex = index;
            // focus
            this.gridMobile.ggrid("activeRow", item);

            Gordic.Epk.Dialogs.DetailZadostiDlg(this, {
                Grid: this.gridMobile,
                Ixp: item.ixp,
                SerCislo: item.ser_cislo,
                Mobile: true,
            }, Global.Enums.ModOtevreni.navigate)
                .then(() => {
                    this.reload();
                })
            
        }

        private clickOnLeft(evt, item: Wfl.Interface.GPodpisovaKnihaDto) {
            console.log("¨click on left");
            const left = $(evt.currentTarget);
            const container = left.parent();
            const right = container.children(".right");
            if (left.hasClass("left-swipe"))
                this.runSettlement(item, Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani, container);
            else {
                console.log("left button is not swiped");
                right.removeClass("right-swipe");
                left.addClass("left-swipe");
            }
        }

        private clickOnRight(evt, item: Wfl.Interface.GPodpisovaKnihaDto) {
            console.log("¨click on right");
            const right = $(evt.currentTarget);
            const container = right.parent();
            const left = container.children(".left");
            if (right.hasClass("right-swipe"))
                this.runSettlement(item, Gordic.Wfl.Interface.GWflczpvEnum.Povoleno, container);
            else {
                console.log("right button is not swiped");
                left.removeClass("left-swipe");
                right.addClass("right-swipe");
            }
        }

        private getParams(zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            if (row == null)
                return null;

            var params: Wfl.Interface.GEpkCompleteConfigDto = {
                Ixp: row.ixp!,
                SerCislo: row.ser_cislo!,
                IxsDpo: row.ixs_dpo!,
                TypPozadavku: this.vyriditState,
                ZpusobVyrizeni: zpusobVyrizeni,
                DuvodVyrizeni: false,
                CasRazitko: this.casoveRazitko.checked,
                CasRazitkoPrilohy: this.casoveRazitkoPriloha.checked, // thazmuka (14.4.2020)
                PodepsatObraz: this.podepsat.checked,
                PodepsatPrilohy: this.podepsatPrilohy.checked,
                PredPodepsanimKonvertovat: this.zkonvertovat.checked,
                ZkonvertovatPrilohy: this.zkonvertovatPrilohy.checked,
                PodepsatPrilohyNePdf: this.podepsatPrilohyNePDF.checked,
                GuidGFRM: ""
            }

            return params;
        }

        private runSettlement(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum, container: JQuery<HTMLElement>) {

            this.menuPosoudit = { enabled: false };
            this.menuSchvalit = { enabled: false };
            this.menuZamitnout = { enabled: false };

            this.common.preSetStates({
                cnt: this,
                row: row,
                sessionIxsFunFlag: this.common.isRequestMineAndActive(row, this.ixs_fun),
                setChecks: true,
                multi: false
            })

            const dto = this.getParams(zpusobVyrizeni, row);

            if (dto == null) {
                this.sendNotification(row.ixp!, "jres:32000970", "warning"); //RC 32000970 : Nejsou k dispozici data žádosti. Nelze provést vyřízení.
                return;
            }

            if (zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.Povoleno) {
                if (this.menuSchvalit.enabled === false) {
                    this.sendNotification(row.ixp!, "jres:32000969", "warning"); //RC 32000969 : Kladné vyřízení žádosti není povoleno.
                    return;
                }
            }
            else if (zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) 
            {
                if (this.menuZamitnout.enabled === false) {
                    this.sendNotification(row.ixp!, "jres:32000968", "warning"); //RC 32000968 : Vrácení žádosti k přepracování není povoleno.
                    return;
                }
            }

            if (dto != null) {
                const done = () => {
                    container.slideUp();
                    this.reload();
                };
                const list: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                list.push(dto);
                new Settlement({ cnt: this, done: done, row: row }).run(list);

            }
            else {
                this.sendNotification(row.ixp!, "jres:32000943", "error"); //RC 32000943 : Při vyřízení došlo k neočekávané chybě.
            }
        }

        private sendNotification(ixp: string, content: string, state: GState) {

            ixp = ixp == null ? "" : ixp;
            content = content == null ? "" : content;

            var opt: IGNotificationOptions = {
                id: "idNot" + ixp,
                title: "jres:32000774 " + ixp, //RC 32000774 : Vyřízení žádosti
                content: content,
                icon: "fa-globe",
                state: state,
            }
            var notObs = new GObservableObject(opt);
            $.content().notification("add", notObs, true);
        }

        private registerSwipeEvents(panel: JQuery<HTMLElement>) {

            var xDown = null;
            var yDown = null;

            function getTouches(evt) {
                return evt.touches || // browser API
                    evt.originalEvent.touches; // jQuery
            }

            function handleTouchStart(evt) {
               // evt.preventDefault();

                const firstTouch = getTouches(evt)[0];
                xDown = firstTouch.clientX;
                yDown = firstTouch.clientY;
            };

            function handleTouchMove(evt) {
               // evt.preventDefault();

                const left = $(evt.currentTarget).children(".left");
                const right = $(evt.currentTarget).children(".right");
                const content = $(evt.currentTarget).children(".content");

                if (!xDown || !yDown) {
                    return;
                }

                var xUp = evt.touches[0].clientX;
                var yUp = evt.touches[0].clientY;
                var xDiff = xDown - xUp;
                var yDiff = yDown - yUp;

                // console.log("xDiff", xDiff);
                // console.log("yDiff", yDiff);

                var diff = Math.abs(xDiff) > Math.abs(yDiff);

                /*most significant*/
                if (diff) {

                    if (xDiff > 0) {
                        /** remove left swipe */
                        $(left).removeClass("left-swipe");
                        $(content).removeClass("left-swipe");
                        /* right swipe */
                        $(right).addClass("right-swipe");
                        $(content).addClass("right-swipe");

                    } else {
                        /** remove right swipe */
                        $(right).removeClass("right-swipe");
                        $(content).removeClass("right-swipe");
                        /* left swipe */
                        $(left).addClass("left-swipe");
                        $(content).addClass("left-swipe");

                    }
                } else {
                    if (yDiff > 0) {
                        /* down swipe */
                    } else {
                        /* up swipe */
                    }
                }
                /* reset values */
                xDown = null;
                yDown = null;
            };

            const containers = panel.children(".container");
            containers.each(function () {
                const container = $(this);
                // mobile
                container[0].addEventListener('touchstart', handleTouchStart, false);
                container[0].addEventListener('touchmove', handleTouchMove, false);
            });

        }

        //#region -- MULTI SETTLEMENT --

        private states: GEpkRowState;

        private multiSettlement(zpus_vyriz: Wfl.Interface.GWflczpvEnum, rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {
            // set init data to rows
            rows.map((row) => {
                row["zpus_vyriz"] = zpus_vyriz;
                this.states = this.setStateOnRow(row);
                this.setNewPropertyToRow(row, this.states);
            })

            var change = (opt: { ixp: string, success: boolean, message?: string }) => {

            };
                
            var done = () => {
                console.info("jres:32000931") //RC 32000931 : Hromadné vyřízení v EPK bylo dokončeno.
                this.reload();
            };

            var obj = this.createEpkCompleteConfigDto(rows);
            // this as any, true, change, done
            new Settlement({cnt: this, change: change, done: done}).run(obj.configList);

        }

        private createEpkCompleteConfigDto(rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {
            var list = rows.map((row) => {
                //let signFavorite = (row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) ? true : false;
                let obj: Wfl.Interface.GEpkCompleteConfigDto = {
                    Ixp: row.ixp,
                    SerCislo: row.ser_cislo,
                    IxsDpo: row.ixs_dpo,
                    VyrizeniTxt: row.vyrizeni_txt,
                    TypPozadavku: row.typ_pozad_pod,
                    ZpusobVyrizeni: row.zpus_vyriz,
                    CasRazitko: row[this.timeStampColumnName],
                    CasRazitkoPrilohy: row[this.timestampAttachmentColumnName],
                    PodepsatObraz: row[this.signFavorite],
                    PodepsatPrilohy: row[this.signAttachmentColumnName],
                    PodepsatPrilohyNePdf: row[this.signAttachmentNoPDFColumnName],
                    PredPodepsanimKonvertovat: row[this.convertColumnName],
                    ZkonvertovatPrilohy: row[this.convertAttachmentColumnName]
                }
                return obj;
            });
            return { rows: rows, configList: list };
        }

        private setStateOnRow(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            // nastavení vstupních hodnot pro upřesnění vyřízení
            var dto = this.common.setInitSettlementValues(this);
            dto = this.setCheckOnRows(row, dto);
            dto = this.setEnableOnRows(row, dto);
            return dto;
        }

        private setCheckOnRows(row: Wfl.Interface.GPodpisovaKnihaDto, dto: GEpkRowState) {

            dto.podepsat.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
            dto.schvalit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Schvalit || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
            dto.podepsatPrilohy.checked = row.s_pri !== 0 || (this.EpkParams.epk_zaskpril === "1");
            dto.posoudit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Posoudit;
            dto.vzitnavedomi.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi;

            // speciality pro UKR
            dto.splnit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Splnit;
            dto.rozhodnout.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Rozhodnout;

            // specialita pro MD (thazmuka - 8.2.2021)
            dto.pridelit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Prideleni;
            dto.pridelit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Predani;
            dto.pridelit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu;

            // zde probíhá nastavení property checked, visible
            this.common.loadCheckBoxSettingsMulti(dto, row, this);

            if (row.prizCasRazitko! > -1) {
                dto.casoveRazitko.checked = row.prizCasRazitko === 0 ? false : true;
                dto.casoveRazitkoPriloha.checked = row.prizCasRazitko === 0 ? false : true;
            }

            dto.casoveRazitko.checked = dto.casoveRazitko.checked && dto.podepsat.checked;
            dto.podepsatPrilohy.checked = dto.podepsatPrilohy.checked && (dto.podepsat.checked || this.common.canChangeRequestType(this.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod));
            dto.casoveRazitkoPriloha.checked = dto.casoveRazitkoPriloha.checked && dto.podepsatPrilohy.checked;
            dto.zkonvertovat.checked = dto.zkonvertovat.checked && dto.podepsat.checked;
            dto.zkonvertovatPrilohy.checked = dto.zkonvertovatPrilohy.checked && dto.podepsatPrilohy.checked;
            dto.podepsatPrilohyNePDF.checked = dto.podepsatPrilohyNePDF.checked && dto.podepsatPrilohy.checked;

            return dto;

        }

        private setEnableOnRows(row: Wfl.Interface.GPodpisovaKnihaDto, dto: GEpkRowState) {

            //#region -- existuje úkon schválení --
            var existujeUkonSchvaleni = false;
            if (row.ixs_spd != null && row.ixs_spd != "") {
                existujeUkonSchvaleni = row.poc_posouz != 0;
            }
            //#endregion

            var jizVyrizen = false; //row.zpus_vyriz !== 0 ? true : false;
            var jeSystemovyUkon = row.sys_ukon != null ? true : false;
            var readOnly = true; // this.isReadOnly == null ? false : this.isReadOnly;
            var jePevnaSablona = row.rezim_sch === 0 ? true : false;        // thazmuka (28.03.2021) - v případě pevné šablony nelze měnit typ žádosti

            var canRequestBeSigned = this.common.canRequestBeSigned(this.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod);
            var canChangeRequestType = this.common.canChangeRequestType(this.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod);

            // thazmuka (29.10.2020) - po konzultaci s M.Halíkem upraveno: když lze podepsat pouze přílohy a lze měnit typy požadavků, nekontroluji schvalovací proces
            // thazmuka (14.6.2022) - přidáno do multi vyřízení, kde chybělo
            // v TK to není takto správně obslouženo
            if (this.EpkParams.epk_povpodppri! === true && canChangeRequestType === true) {
                dto.podepsat.enabled = this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && (this.EpkOpt.povoleniUkonuPodpisuEpk!);
                dto.schvalit.enabled = this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && existujeUkonSchvaleni === false;
            }
            else {
                dto.podepsat.enabled = (row.dat_vyriz_plan == null || row.priz_rsp !== 10) && this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && (this.EpkOpt.povoleniUkonuPodpisuEpk!);
                dto.schvalit.enabled = (row.dat_vyriz_plan == null || row.priz_rsp !== 10) && this.common.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && existujeUkonSchvaleni === false;
            }

            // TUTO HODNOTY UŽIVATEL NEMŮŽE MĚNIT (po domluvě s M.Halik 22.4.2020)
            dto.posoudit.enabled = false;
            dto.vzitnavedomi.enabled = false;
            dto.splnit.enabled = false;
            dto.rozhodnout.enabled = false;
            dto.pridelit.enabled = false;
            dto.predat.enabled = false;
            dto.schvaleniVyrizeniSpisu.enabled = false;

            // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka dle db parametru (řízení a viditelnost)
            // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
            if (this.EpkParams.gin_sgn_ktgdp === false)  // pokud nejsou aktivovány kategorie důvodu podpisu
                dto.casoveRazitko.enabled = canRequestBeSigned && dto.podepsat.checked;
            //dto.casoveRazitko.enabled = row.prizCasRazitko! > -1 ? false : canRequestBeSigned && dto.podepsat.checked;

            // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka dle db parametru (řízení a viditelnost)
            // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
            if (this.EpkParams.gin_sgn_ktgdp === false)  // pokud nejsou aktivovány kategorie důvodu podpisu
                dto.casoveRazitkoPriloha.enabled = dto.podepsatPrilohy.checked;
            //dto.casoveRazitkoPriloha.enabled = row.prizCasRazitko! > -1 ? false : dto.podepsatPrilohy.checked;

            dto.zkonvertovat.enabled = dto.podepsat.checked;
            dto.podepsatPrilohy.enabled = dto.podepsat.checked || (canRequestBeSigned && this.EpkParams.epk_povpodppri!) && row.priz_epk_pocet === 0 && row.s_pri === 0;
            dto.zkonvertovatPrilohy.enabled = dto.podepsatPrilohy.checked;
            dto.podepsatPrilohyNePDF.enabled = dto.podepsatPrilohy.checked;

            return dto;
        }

        /** podepsat obraz */
        private signFavorite = "signFavorite";
        /** timestamp */
        private timeStampColumnName = "timestamp";
        /** signAttachment */
        private signAttachmentColumnName = "signAttachment";
        /** convert */
        private convertColumnName = "convert";
        /** timestampAttachment */
        private timestampAttachmentColumnName = "timestampAttachment";
        /** convertAttachment */
        private convertAttachmentColumnName = "convertAttachment";
        /** signAttachmentNoPDF */
        private signAttachmentNoPDFColumnName = "signAttachmentNoPDF";

        private setNewPropertyToRow(row, dto: GEpkRowState) {

            // doplněný důvod vyřízení (thazmuka 15.7.2022)
            var settlementReason: string | null = null;
            if (row.ixp != null && row.ser_cislo != null) {
                var keyPath = String.Format("settlementReason.{0}{1}", row.ixp!, row?.ser_cislo?.toString());
                if (this.globalSettings != null && keyPath !== "") {
                    var value: string = this.globalSettings.get(keyPath);
                    settlementReason = value == null ? "" : value.trim();
                }
            }

            if (settlementReason != null) {
                row.vyrizeni_txt = settlementReason;
            }

            // uložení, že chci podepsat obraz
            row[this.signFavorite] = dto.podepsat.checked;
            row[this.timeStampColumnName] = dto.casoveRazitko.checked;
            row[this.timeStampColumnName + "Enabled"] = dto.casoveRazitko.enabled;
            row[this.convertColumnName] = dto.zkonvertovat.checked;
            row[this.convertColumnName + "Enabled"] = dto.zkonvertovat.enabled;
            row[this.signAttachmentColumnName] = dto.podepsatPrilohy.checked;
            row[this.signAttachmentColumnName + "Enabled"] = dto.podepsatPrilohy.enabled;
            row[this.timestampAttachmentColumnName] = dto.casoveRazitkoPriloha.checked;
            row[this.timestampAttachmentColumnName + "Enabled"] = dto.casoveRazitkoPriloha.enabled;
            row[this.convertAttachmentColumnName] = dto.zkonvertovatPrilohy.checked;
            row[this.convertAttachmentColumnName + "Enabled"] = dto.zkonvertovatPrilohy.enabled;
            row[this.signAttachmentNoPDFColumnName] = dto.podepsatPrilohyNePDF.checked;
            row[this.signAttachmentNoPDFColumnName + "Enabled"] = dto.podepsatPrilohyNePDF.enabled;
        }

        //#endregion

    }

    // todo: sjednotit metody s hromadného vyřízení s metodou zde!

}

